import type { ProjectGraphDirectiveStatement, ProjectGraphTaskSchedule } from '@avisoma/shared';
import { directiveLines, scheduleLines } from './taskSchedule';

/**
 * The selected task's schedule or AD's statement, one muted line per stated part; nothing when the sheet states none.
 */
export function TaskSchedule({
  schedule,
  unknown,
  directive,
}: {
  schedule: ProjectGraphTaskSchedule | undefined;
  unknown?: true;
  directive?: ProjectGraphDirectiveStatement;
}) {
  const lines = [...scheduleLines(schedule, unknown === true), ...directiveLines(directive)];
  if (lines.length === 0) return null;
  return (
    <div className="text-zinc-500 dark:text-zinc-400">
      {lines.map((line) => (
        <div key={line}>{line}</div>
      ))}
    </div>
  );
}
